import { Modal, Button, BUTTON_THEMES } from 'ht-styleguide';

import { TGenericModalProps } from '@scenes/HomeHub/homehub.types';

const WhyWeAskModal = ({ isVisible, hide, info }: TGenericModalProps) => (
  <Modal
    isVisible={isVisible}
    hide={hide}
    header="Why we ask"
    footerElement3={
      <Button theme={BUTTON_THEMES.PRIMARY} onClick={hide}>
        Got it
      </Button>
    }
  >
    <div className="p1">{info}</div>
  </Modal>
);

export default WhyWeAskModal;
